import Layout from "@views/layout";

const communityDashboardIndexRouter = {
    path: "/dashboard/index",
    component: Layout,
    redirect: "/dashboard/index/index",
    meta: {
        title: "首页",
        icon: "el-icon-document",
    },
    children: [
        {
            path: "index",
            name: "COMMUNITY_DASHBOARD_INDEX_INDEX",
            component: () => import("@views/dashboard/index/index.vue"),
            meta: {
                title: "首页",
                keepAlive: false,
            },
        },
    ],
};

export default communityDashboardIndexRouter;
